const payments = [
  {
    text: "M-Pesa",
    enable: true,
    type: "MPESA_KENYA",
    merchantId: 9,
    img: "../assets/images/home/m_pasa.png",
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "M-Pesa",
    enable: true,
    type: "MPESA_KENYA",
    merchantId: 16,
    img: "../assets/images/home/mpasa.png",
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "M-Pesa",
    enable: true,
    type: "MPESA_KENYA",
    merchantId: 35,
    img: "../assets/images/home/mpasa.png",
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "Tarspay",
    enable: true,
    type: "Tarspay",
    merchantId: 38,
    img: "",
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "PAY F",//futurepay
    enable: true,
    type: "futurepay",
    merchantId: 51,
    img: "",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "PAY IN",//inpay
    enable: true,
    type: "inpay",
    merchantId: 58,
    isHideDepositPageBlock: true,//隐藏充值
    isHideWithdraw: false,//显示提款
    img: "",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "M-Pesa",//inpay
    enable: true,
    type: "8",
    merchantId: 58,
    isHideDepositPageBlock: false,//显示充值
    isHideWithdraw: true,//隐藏提款
    img: "../assets/images/home/mpasa.png",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      return true;
    },
  },
  {
    text: "Airtel",//inpay
    enable: true,
    type: "9",
    merchantId: 58,
    isHideDepositPageBlock: false,//显示充值
    isHideWithdraw: true,//隐藏提款
    img: "../assets/images/home/airtel_money.png",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      return true;
    },
  },
];

const codes = [
  // {
  //   codeId: "001",
  //   codeText: "MPS",
  //   codeMsg: "MPS",
  // },
  // {
  //   codeId: "002",
  //   codeText: "airtel",
  //   codeMsg: "airtel",
  // },
  // {
  //   codeId: "003",
  //   codeText: "AIRTZA",
  //   codeMsg: "AIRTZA",
  // },
  // {
  //   codeId: "004",
  //   codeText: "SAFKEN",
  //   codeMsg: "SAFKEN",
  // },
  {
    codeId: "8",
    codeText: "M-Pesa",
    codeMsg: "M-Pesa",
  },
  {
    codeId: "9",
    codeText: "Airtel",
    codeMsg: "Airtel",
  },

];
export default {
  payments: payments.filter((payment) => payment.enable),
  codes: codes,
};
